export default __webpack_public_path__ + "static/media/glitch24.940651e9.png";